// extracted by mini-css-extract-plugin
module.exports = {"airportLabel":"_1em43z"};